import { InputProps } from 'antd/lib/input/Input';
import React, { ReactNode, useState } from 'react';
import { Flex } from '@ui-library/misc';
import { Subtext } from '@ui-library/typography';
import { Input, Label, PasswordIcon } from './styles';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import Tooltip from '@ui-library/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '@css/theme';

type Props = InputProps & {
  isError?: boolean;
  errorMessage?: string;
  errorMessageClass?: string;
  label?: string | ReactNode;
  hideIcon?: boolean;
};

const InputComponent = ({
  label,
  isError,
  errorMessageClass,
  hideIcon,
  errorMessage,
  ...rest
}: Props) => (
  <Flex flexDirection="column">
    {label && <Label>{label}</Label>}
    <Input isError={isError} {...rest} />
    <Flex alignItemsCenter className={errorMessageClass}>
      {isError && (
        <>
          {!hideIcon && (
            <FontAwesomeIcon
              icon={regular('circle-exclamation')}
              className="m-r-xs"
              color={theme.color.error}
            />
          )}
          <Subtext error={isError}>{errorMessage}</Subtext>
        </>
      )}
    </Flex>
  </Flex>
);

export default InputComponent;

type PasswordProps = InputProps & {
  isError?: boolean;
  errorMessageClass?: string;
  label?: string;
  errorMessage?: string;
  testId?: string;
};

export const PasswordInput = ({
  isError,
  className,
  onChange,
  onBlur,
  onKeyDown,
  label,
  onKeyDownCapture,
  errorMessage = '',
  testId,
  errorMessageClass,
}: PasswordProps) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <InputComponent
      data-testid={testId}
      type={showPassword ? 'text' : 'password'}
      label={label}
      errorMessageClass={errorMessageClass}
      isError={isError || errorMessage.length > 0}
      className={className}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDownCapture={onKeyDownCapture}
      onKeyDown={onKeyDown}
      maxLength={128}
      errorMessage={errorMessage}
      suffix={
        <Tooltip title={showPassword ? 'Hide' : 'Show'} trigger="hover" placement="top">
          <PasswordIcon
            data-testid="eye"
            onClick={() => setShowPassword((x) => !x)}
            icon={showPassword ? regular('eye-slash') : regular('eye')}
          />
        </Tooltip>
      }
    />
  );
};

export { Search, PhoneNumber } from './styles';
